import styled from 'styled-components';
import { DynamicExteriorImagePreviewStyled } from '../DynamicExteriorImagePreviewStyled';

export const DynamicExteriorImagePreviewDS = styled(DynamicExteriorImagePreviewStyled)`
    
`;
